import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-settings',
  templateUrl: './services-settings.component.html',
  styleUrls: ['./services-settings.component.scss']
})
export class ServicesSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
